import { StyledProject, StyledButton } from "./styles";
import { FaLink } from "react-icons/fa";
import githubWhite from "../../../assets/github-logo-white.png";
import github from "../../../assets/github-logo.png";
import ProjectAccordion from "../../../components/ProjectAccordion";
import { IProject } from "../projects-data";

export interface IProjectComponentProps {
  project: IProject;
}

const ProjectComponent = ({ project }: IProjectComponentProps) => {
  return (
    <StyledProject>
      <h3>{project.title}</h3>
      <div className="solo-indicator">
        {project.solo ? "Solo project" : "Collaborator"}
      </div>
      <main>
        <img className="project-img" src={project.image} alt="" />

        <div className="right">
          <ProjectAccordion project={project} />
          <div className="btns-container">
            <StyledButton
              onClick={() => window.open(project.repoLink, "_blank")}
            >
              Code
              <img className="github-logo" src={github} alt="" />
            </StyledButton>

            <StyledButton
              onClick={() => window.open(project.demoLink, "_blank")}
            >
              Demo
              <FaLink size={20} />
            </StyledButton>
          </div>
        </div>
      </main>
    </StyledProject>
  );
};

export default ProjectComponent;
